import {
    CountryPostalCodeCity,
    CountryPostalCodeCityComponent,
} from './../../../shared/ui/country-postal-code-city/country-postal-code-city.component';

import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import {FormBuilder, FormControl, ReactiveFormsModule} from '@angular/forms';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {TranslatePipe} from '@brunata-angular/util';
import {InputTextGroupComponent} from '@brunata-angular/ui';
import {Address} from '../models/address.model';

@Component({
    selector: 'app-edit-address-modal',
    templateUrl: './edit-address-modal.component.html',
    styleUrls: ['./edit-address-modal.component.scss'],
    standalone: true,
    imports: [
        TranslatePipe,
        ReactiveFormsModule,
        NgbModule,
        InputTextGroupComponent,
        CountryPostalCodeCityComponent,
    ],
    providers: [ToastrService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditAddressModalComponent implements OnInit {
    @Input() type: 'address' | 'billingAddress' = 'address';
    @Input() address: Address | undefined;
    @Output() submitData = new EventEmitter<Address>();

    formGroup = this.formBuilder.group({
        name: new FormControl<string | null>(null),
        address1: new FormControl<string | null>(null),
        address2: new FormControl<string | null>(null),
        countryAndPostalCode: new FormControl<CountryPostalCodeCity>({
            country: '',
            postalCode: '',
            city: '',
        }),
    });
    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
    ) {}

    submit(): void {
        this.submitData.emit({
            countryCode: this.formGroup.value.countryAndPostalCode?.country ?? '',
            address1: this.formGroup.value.address1 ?? '',
            address2: this.formGroup.value.address2 ?? '',
            city: this.formGroup.value.countryAndPostalCode?.city ?? '',
            postalCode: this.formGroup.value.countryAndPostalCode?.postalCode ?? '',
            name: this.formGroup.value.name ?? '',
        });
        this.activeModal.close();
    }

    ngOnInit(): void {
        if (this.address !== undefined) {
            this.formGroup.controls.name.setValue(this.address.name);
            this.formGroup.controls.address1.setValue(this.address.address1);
            this.formGroup.controls.address2.setValue(this.address.address2);
            this.formGroup.controls.countryAndPostalCode.setValue({
                country: this.address.countryCode ?? '',
                postalCode: this.address.postalCode ?? '',
                city: this.address.city ?? '',
            });
        }
    }
}
